const AppointmentTypeStrings = {
    IN_SHOP: "Inshop",
    MOBILE: "Mobile",
    DROP_OFF: "Dropoff",
    IN_SHOP_OR_DROP_OFF: "InshopOrDropoff",
};

const PREMIUM_TIME_SLOT_ID_FLAG = "-PREMIUM";

const PREMIUM_FEE_PART_TYPE = "EARLY BIRD";

const PRICING_BY_DAY_PART_TYPE = "PREMAPPT GEN";

const RECAL_ACK_YES = "Yes";

const RouteCodeFlags = {
    ALL_DAY_DROP_OFF: "ALL DAY DROP OFF",
    OVERNIGHT_DROP_OFF: "OVERNIGHT DROP OFF",
};

const cmsWidgetFieldMappings = {
    MODAL_CLOSE_BUTTON: "FooterText",
    SUPPLEMENTAL_INFORMATION: "BodyText",
    TIME_SLOT_BUTTON: "HeaderText",
    DISCLAIMER: "FooterText",
    DURATION: "SubheaderText",
};

export {
    AppointmentTypeStrings,
    PREMIUM_TIME_SLOT_ID_FLAG,
    PREMIUM_FEE_PART_TYPE,
    PRICING_BY_DAY_PART_TYPE,
    RouteCodeFlags,
    cmsWidgetFieldMappings,
    RECAL_ACK_YES,
};
